let view = null;

export default {
	namespace: 'template-projects',
	beforeEnter: async ({ current, next, trigger }) => {
		const { default: ProjectsView } = await import(
			/* webpackChunkName: "projects-view" */ '../../templates/ProjectsView'
		);
		view = new ProjectsView(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
